// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.white {
    background-color: white;
    /* opacity: 0.5 !important; */
}

/* .modal-backdrop {
    opacity: 0.5 !important;
} */

div.fullscreen {
    background-color: white;
    width: 100%;
    height: 100%;    
}

/* #logindb.fade.show {
    opacity: 1 !important;
} */

.inactivityBackdrop {
    /* opacity: 0.5; */
    background-color: gray;
}`, "",{"version":3,"sources":["webpack://./src/components/AutoLogout.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,6BAA6B;AACjC;;AAEA;;GAEG;;AAEH;IACI,uBAAuB;IACvB,WAAW;IACX,YAAY;AAChB;;AAEA;;GAEG;;AAEH;IACI,kBAAkB;IAClB,sBAAsB;AAC1B","sourcesContent":[".white {\n    background-color: white;\n    /* opacity: 0.5 !important; */\n}\n\n/* .modal-backdrop {\n    opacity: 0.5 !important;\n} */\n\ndiv.fullscreen {\n    background-color: white;\n    width: 100%;\n    height: 100%;    \n}\n\n/* #logindb.fade.show {\n    opacity: 1 !important;\n} */\n\n.inactivityBackdrop {\n    /* opacity: 0.5; */\n    background-color: gray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
